import React, { useEffect, useState } from 'react';
import CloseIcon from '../../assets/close-panel.svg';
import Emailicon from '../../assets/email-panel.svg';
import envIcon from '../../assets/env-panel.svg';
import { ReactComponent as TableauIcon } from '../../assets/tableau-filled.svg';
import { ReactComponent as TeradataIcon } from '../../assets/teradata.svg';
import { ReactComponent as DollarcircleIcon } from '../../assets/dollar-circle.svg';
import { ReactComponent as ChartIcon } from '../../assets/chart.svg';
import { ReactComponent as DatabricksIcon } from '../../assets/databricks.svg';
import { ReactComponent as PrestoIcon } from '../../assets/simple-icons_presto.svg';
import { ReactComponent as PowerBIIcon } from '../../assets/simple-icon_powerbi.svg';
import { ReactComponent as VerificationIcon } from '../../assets/simple-icons_vv.svg';
import { ReactComponent as ControlsIcon } from '../../assets/controls-icons.svg';
import sideArrow from '../../assets/side-arrow.svg';
import downArrow from '../../assets/down-arrow.svg';
import quickLink from '../../assets/quill_link-out.svg';
import moment from 'moment-timezone';
import './RulesEngine.css';
import { ReactComponent as AlteryxIcon } from '../../assets/Alteryx.svg';
import { ReactComponent as DenodoIcon } from '../../assets/Denodo.svg';
import { ReactComponent as ActiveDenodoIcon } from '../../assets/Denodo_Selected.svg';
import { ReactComponent as  TrifactaIcon} from '../../assets/Trifacta.svg';

interface Props {
	close: () => void;
	ruledata: any;
}

function dataConvertFunc(lastRefreshedAt: any) {
		const lastRefresh: any = new Date(lastRefreshedAt);
		const today: any = new Date();
		const diffDate = lastRefresh - today;
		const diffCount = diffDate / (1000 * 60 * 60 * 24);
		const staleday = Math.abs(diffCount).toFixed(0);
		return staleday;
	}

function CostRound(cost: any) {
	const cost1 = Number.parseFloat(cost);
	const roundedCost = Number.parseFloat(cost1.toFixed(2));
	return roundedCost;
}

	function MillisecondsToMinutes(count: any) {
		// Convert milliseconds to hours and minutes
		const hours = Math.floor(count / (1000 * 60 * 60));
		const minutes = Math.round((count % (1000 * 60 * 60)) / (1000 * 60));
		// Format the result
		const formattedResult = `${hours}H ${minutes}M`;
		return formattedResult;
	}
	

// Helper functions and subcomponents for RulesEngine to reduce cognitive complexity
const getObservationTitle = (rule: string): string => {
	switch (rule) {
		case 'CPU Threshold Breach':
			return 'Utilization %';
		case 'Orphaned Users':
			return 'Orphaned\nUser Count';
		case 'Orphaned Datasets':
			return 'Orphaned\nDataset Count';
		case 'Capacity Threshold Breach':
		case 'PBI Gateway Version':
		case 'Datasets Refresh Failure':
		case 'Total Dataset Refresh Failure':
		case 'Inactive Users':
		case 'Unlicensed Users':
		case 'Users Never Logged In':
		case 'Patch Upgrade has Valid Approval and CR':
		case 'Access Not Approved By Process Owner':
		case 'Access Approved Prior To Granting Of Access':
		case 'Access Granted Without Proper Request':
		case 'Dormant Users Check':
		case 'Details Of CR Raised Or Not For Key System Config Changes':
		case 'Access Grantor Different From Approver':
		case 'Privileged Access Was Not Reviewed And Approved':
		case 'Reviewer Authorization Check':
		case 'Key System Configuration Check Approval':
		case 'Inappropriate Login Activities Risk Assessment':
		case 'Terminated Users Active Access Check':
			return 'Count';
		default:
			return '';
	}
};

const getRuleHeaderTitle = (ruleName: string): string => {
	if (ruleName === 'Extract Failures' || ruleName === 'Orphan Extracts') {
		return 'Extracts';
	}
	if (ruleName === 'Orphan Workbooks') {
		return 'Workbooks';
	}
	if (ruleName === 'Tableau Growth') {
		return 'Extracts(Environment)';
	}
	if (ruleName === 'Databricks Growth') {
		return 'Storage A/C Name';
	}
	if (ruleName === 'Powerbi Growth') {
		return 'Capability';
	}
	return '';
};

const getRuleHeader2 = (ruleName: string): string => {
	if (ruleName === 'Tableau Growth' || ruleName === 'Databricks Growth') {
		return 'Size(This Month)';
	}
	return '';
};

const getRuleHeader3 = (ruleName: string): string => {
	if (ruleName === 'Extract Failures') {
		return 'Occurrences';
	}
	if (ruleName === 'Orphan Extracts' || ruleName === 'Orphan Workbooks') {
		return 'Stale Days';
	}
	if (ruleName === 'Tableau Growth') {
		return 'Size(Last Month)';
	}
	if (ruleName === 'Databricks Growth') {
		return 'Size(Past 3 Months)';
	}
	if (ruleName === 'Powerbi Growth') {
		return 'Count';
	}
	return '';
};

const getRuleHeader4 = (ruleName: string): string => {
	if (ruleName === 'Query Failures') {
		return 'Status';
	}
	if (ruleName === 'Long running Batch Id queries') {
		return 'Duration';
	}
	return '';
};

const getPowerBiHeader = (ruleName: string): string => {
	if (ruleName === 'CPU Threshold Breach' || ruleName === 'Datasets Refresh Failure') {
		return 'Capacity Name';
	}
	if (
		ruleName === 'Orphaned Datasets' ||
		ruleName === 'Orphaned Users' ||
		ruleName === 'Inactive Users' ||
		ruleName === 'Unlicensed Users' ||
		ruleName === 'Users Never Logged In' ||
		ruleName === 'Data Sources Not Using Service Account' ||
		ruleName === 'Total Dataset Refresh Failure' ||
		ruleName === 'Capacity Threshold Breach' ||
		ruleName === 'PBI Gateway Version'
	) {
		return 'Capability';
	}
	if (ruleName === 'Tenant Settings (TS) Mismatch') {
		return 'Tenant Name';
	}
	if (
		ruleName === 'Patch Upgrade has Valid Approval and CR' ||
		ruleName === 'Patch Upgrade Has Valid Approval & CR' ||
		ruleName === 'Access Not Approved By Process Owner' ||
		ruleName === 'Access Approved Prior To Granting Of Access' ||
		ruleName === 'Is SSO Enabled?' ||
		ruleName === 'Access Granted Without Proper Request' ||
		ruleName === 'Patch Monitoring Check' ||
		ruleName === 'Dormant Users Check' ||
		ruleName === 'Details Of CR Raised Or Not For Key System Config Changes' ||
		ruleName === 'Access Grantor Different From Approver' ||
		ruleName === 'Privileged Access Was Not Reviewed And Approved' ||
		ruleName === 'Reviewer Authorization Check' ||
		ruleName === 'Key System Configuration Check Approval' ||
		ruleName === 'Inappropriate Login Activities Risk Assessment' ||
		ruleName === 'Terminated Users Active Access Check' ||
		ruleName === 'Key System Configuration Check'
	) {
		return 'Tool';
	}
	return '';
};

const getDatabricksHeader1 = (ruleName: string): string => {
	if (ruleName === 'Long Running Clusters') {
		return 'Cluster';
	}
	if (ruleName === 'Job Failures' || ruleName === 'Long Running Jobs') {
		return 'Job';
	}
	if (ruleName === 'Spend Threshold Breach') {
		return 'Workspace';
	}
	return '';
};

const getDatabricksHeader2 = (ruleName: string): string => {
	if (
		ruleName === 'Long Running Clusters' ||
		ruleName === 'Job Failures' ||
		ruleName === 'Long Running Jobs'
	) {
		return 'Duration';
	}
	if (ruleName === 'Spend Threshold Breach') {
		return 'Total DBU Cost';
	}
	return '';
};

const truncateCapacityName = (name: string | undefined): string => {
	if (name && name.length > 20) {
		return name.substring(0, 22) + '...';
	}
	return name || '';
};

const truncateDatasetName = (name: string | undefined): string => {
	if (name && name.length > 20) {
		return name.substring(0, 24) + '...';
	}
	return name || '';
};

const truncateStorageAccount = (account: string | undefined): string => {
	if (account && account.length > 13) {
		return account.slice(0, 13) + '...';
	}
	return account || '';
};

const truncateGeneralName = (name: string | undefined): string => {
	if (!name) return 'Untitled';
	if (name.length > 20) {
		return name.substring(0, 16) + '...';
	}
	return name;
};

const ObservationItem: React.FC<{ obs: any; rule: string }> = ({ obs, rule }) => {
	if (!obs) return null;

	const renderName = () => {
		if (rule === 'Datasets Refresh Failure') {
			return (
				<>
					<span className="inner-observations-name" title={obs?.CapacityName}>
						{truncateCapacityName(obs?.CapacityName)}
					</span>
					<span className="inner-observations-name" title={obs?.DatasetName}>
						{truncateDatasetName(obs?.DatasetName)}
					</span>
				</>
			);
		}

		return (
			<span
				className={rule === 'Tableau Growth' ? 'inner-observations-name1' : 'inner-observations-name'}
				title={obs?.name}
			>
				{rule === 'Databricks Growth' ? (
					<span className="inner-observations-count" title={obs?.Storage_Account}>
						{truncateStorageAccount(obs?.Storage_Account)}
					</span>
				) : (
					<span className="" title={obs?.name}>
						{truncateGeneralName(obs?.name)}
					</span>
				)}
			</span>
		);
	};

	const renderCountOrMetric = () => {
		if (rule === 'Tableau Growth') {
			return <span className="inner-observations-count">{obs.currentSizeInMB} MB</span>;
		}
		if (rule === 'Databricks Growth') {
			return (
				<span className="inner-observations-count">
					{obs.size_in_current_month === null ? '--': obs.size_in_current_month.toFixed(2) + ' GB' }
				</span>
			);
		}
		if (rule === 'Orphan Extracts' || rule === 'Orphan Workbooks') {
			return <span className="inner-observations-count">{dataConvertFunc(obs.lastRefreshedAt)} days</span>;
		}
		return null;
	};

	const renderExtraMetric = () => {
		if (rule === 'Tableau Growth') {
			return <span className="inner-observations-count">{obs.lastmonthSizeInMB} MB</span>;
		}
		if (rule === 'Databricks Growth') {
			return (
				<span className="inner-observations-count">
					{obs.avg_size_past_3_months === null ? '--': obs.avg_size_past_3_months.toFixed(2) + ' GB' }
				</span>
			);
		}
		if (rule === 'Spend Threshold Breach') {
			return <span className="inner-observations-count">$ {CostRound(obs.AverageCost)}</span>;
		}
		if (rule === 'Long Running Clusters') {
			return <span className="inner-observations-count">{MillisecondsToMinutes(obs.count)}</span>;
		}
		if (rule === 'Job Failures') {
			return <span className="inner-observations-count">{MillisecondsToMinutes(obs.runTime)}</span>;
		}
		if (rule === 'Long Running Jobs') {
			return <span className="inner-observations-count">{MillisecondsToMinutes(obs.count)}</span>;
		}

		const excludeRules = [
			'Tableau Growth',
			'Orphan Extracts',
			'Orphan Workbooks',
			'Spend Threshold Breach',
			'Long Running Clusters',
			'Job Failures',
			'Long Running Jobs',
			'Data Sources Not Using Service Account',
			'Tenant Settings (TS) Mismatch',
			'Databricks Growth',
			'Patch Upgrade Has Valid Approval & CR',
			'Is SSO Enabled?',
			'Patch Monitoring Check',
			'Key System Configuration Check'
		];

		if (!excludeRules.includes(rule)) {
			return <span className="inner-observations-count">{obs.count}</span>;
		}

		return null;
	};

	return (
		<li className="inner-observation">
			{renderName()}
			{renderCountOrMetric()}
			{renderExtraMetric()}
		</li>
	);
};

const RuleViewDetails: React.FC<{
	innerArray: any;
	selectedRule: string;
	close: () => void;
}> = ({ innerArray, selectedRule, close }) => {
	const renderTextLink = () => {
		if (selectedRule === 'Tableau Observability') {
			return (
				<a href={`/tableau/observation?ruleName=${innerArray.rule}`} onClick={close}>
					View Details
				</a>
			);
		}
		if (selectedRule === 'Presto Observability') {
			return (
				<a href={`/presto/observation?ruleName=${innerArray.rule}`} onClick={close}>
					View Details
				</a>
			);
		}
		if (selectedRule === 'Databricks Observability') {
			return (
				<a href={`/databricks/observation?ruleName=${innerArray.rule}`} onClick={close}>
					View Details
				</a>
			);
		}
		if (innerArray.rule === 'Databricks Growth' || innerArray.rule === 'Tableau Growth') {
			return (
				<a href={`/dataGrowth/observation?ruleName=${innerArray.rule}`} onClick={close}>
					View Details
				</a>
			);
		}

		const standardRules = [
			'CPU Threshold Breach',
			'Orphaned Users',
			'Orphaned Datasets',
			'Datasets Refresh Failure',
			'Databricks Growth',
			'Capacity Threshold Breach',
			'Data Sources Not Using Service Account',
			'PBI Gateway Version',
			'Tenant Settings (TS) Mismatch',
			'Total Dataset Refresh Failure',
			'Inactive Users',
			'Unlicensed Users',
			'Users Never Logged In',
			'Powerbi Growth',
			'Patch Upgrade has Valid Approval and CR',
			'Patch Upgrade Has Valid Approval & CR',
			'Access Not Approved By Process Owner',
			'Access Approved Prior To Granting Of Access',
			'Is SSO Enabled?',
			'Access Granted Without Proper Request',
			'Patch Monitoring Check',
			'Dormant Users Check',
			'Details Of CR Raised Or Not For Key System Config Changes',
			'Access Grantor Different From Approver',
			'Privileged Access Was Not Reviewed And Approved',
			'Reviewer Authorization Check',
			'Key System Configuration Check Approval',
			'Inappropriate Login Activities Risk Assessment',
			'Terminated Users Active Access Check',
			'Key System Configuration Check'
		];

		if (standardRules.includes(innerArray.rule)) {
			return (
				<a href={`${innerArray.clickActionUrl}`} onClick={close}>
					View Details
				</a>
			);
		}

		return (
			<a href="/LandingPage" onClick={close}>
				View Details
			</a>
		);
	};

	const renderIconLink = () => {
		if (selectedRule === 'Tableau Observability') {
			return (
				<a href={`/tableau/observation?ruleName=${innerArray.rule}`} onClick={close}>
					<img src={quickLink} alt="link" />
				</a>
			);
		}
		if (selectedRule === 'Presto Observability') {
			return (
				<a href={`/presto/observation?ruleName=${innerArray.rule}`} onClick={close}>
					<img src={quickLink} alt="link" />
				</a>
			);
		}
		if (selectedRule === 'Databricks Observability') {
			return (
				<a href={`/databricks/observation?ruleName=${innerArray.rule}`} onClick={close}>
					<img src={quickLink} alt="link" />
				</a>
			);
		}
		if (innerArray.rule === 'Databricks Growth' || innerArray.rule === 'Tableau Growth') {
			return (
				<a href={`/dataGrowth/observation?ruleName=${innerArray.rule}`} onClick={close}>
					<img src={quickLink} alt="link" />
				</a>
			);
		}

		const standardRulesWithIcon = [
			'CPU Threshold Breach',
			'Orphaned Users',
			'Orphaned Datasets',
			'Datasets Refresh Failure',
			'Databricks Growth',
			'Capacity Threshold Breach',
			'Data Sources Not Using Service Account',
			'PBI Gateway Version',
			'Tenant Settings (TS) Mismatch',
			'Total Dataset Refresh Failure',
			'Inactive Users',
			'Unlicensed Users',
			'Users Never Logged In',
			'Patch Upgrade has Valid Approval and CR',
			'Patch Upgrade Has Valid Approval & CR',
			'Access Not Approved By Process Owner',
			'Access Approved Prior To Granting Of Access',
			'Is SSO Enabled?',
			'Access Granted Without Proper Request',
			'Patch Monitoring Check',
			'Dormant Users Check',
			'Details Of CR Raised Or Not For Key System Config Changes',
			'Access Grantor Different From Approver',
			'Privileged Access Was Not Reviewed And Approved',
			'Reviewer Authorization Check',
			'Key System Configuration Check Approval',
			'Inappropriate Login Activities Risk Assessment',
			'Terminated Users Active Access Check',
			'Key System Configuration Check',
			'Powerbi Growth'
		];

		if (standardRulesWithIcon.includes(innerArray.rule)) {
			return (
				<a href={`${innerArray.clickActionUrl}`} onClick={close}>
					<img src={quickLink} alt="link" />
				</a>
			);
		}

		return (
			<a href="/LandingPage" onClick={close}>
				<img src={quickLink} alt="link" />
			</a>
		);
	};

	return (
		<div className="view-details">
			<div className="date">
				{moment(innerArray.lastProcess).format('DD-MM-YYYY')}
				<div className="link">
					<div>{renderTextLink()}</div>
				</div>
				<div className="icon">
					<div>{renderIconLink()}</div>
				</div>
			</div>
		</div>
	);
};

const RuleObservationGroup: React.FC<{
	innerArray: any;
	index: number;
	expandedRule: any;
	handleToggle: (index: number) => void;
	selectedRule: string;
	close: () => void;
}> = ({ innerArray, index, expandedRule, handleToggle, selectedRule, close }) => {
	const isExpanded = expandedRule === index;

	return (
		<div style={{ marginBottom: '5px' }} className="data-container">
			<button
				type="button"
				className="rule-title-banner"
				onClick={() => handleToggle(index)}
				onKeyDown={(e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						handleToggle(index);
					}
				}}
				style={{
					background: 'none',
					border: 'none',
					width: '100%',
					fontFamily: 'inherit',
					color: 'inherit',
					textAlign: 'left',
					padding: '18px 12px 0px 12px'
				}}
			>
				<span className="rule-title">
					{isExpanded ? <img alt="down" src={downArrow} /> : <img src={sideArrow} alt="side" />}
					<span>{innerArray.rule === 'Inactive Users' ? 'Not logged in last 90 days' : innerArray.rule}</span>
				</span>
				<span className="observation-count">
					<span className="rule-circle-count">{innerArray.totalObservation}</span>
				</span>
			</button>
			{isExpanded && (
				<div style={{ padding: '0px 15px 0px 25px' }}>
					<ul className="innerrules">
						{console.log(innerArray, 'data1')}
						<li className="inner-observation">
							<span className="inner-observations-name title">
								{getRuleHeaderTitle(innerArray.rule)}
							</span>
							<span className="inner-observations-count title">
								{getRuleHeader2(innerArray.rule)}
							</span>
							<span className="inner-observations-count title">
								{getRuleHeader3(innerArray.rule)}
							</span>
							<span className="inner-observations-count title">
								{getRuleHeader4(innerArray.rule)}
							</span>
						</li>

						{/* PowerBI Alerts */}
						<li className="inner-observation">
							<span className="inner-observations-name title">
								{getPowerBiHeader(innerArray.rule)}
							</span>
							<span className="inner-observations-name title1">
								{innerArray.rule === 'Datasets Refresh Failure' ? 'Dataset Name' : ''}
							</span>
							<span className="inner-observations-name title1">{getObservationTitle(innerArray.rule)}</span>
						</li>

						{/* Databricks Alerts */}
						<li className="inner-observation">
							<span className="inner-observations-name title">
								{getDatabricksHeader1(innerArray.rule)}
							</span>

							<span className="inner-observations-count title">
								{getDatabricksHeader2(innerArray.rule)}
							</span>
						</li>

						{innerArray.observations.map(
							(obs: any, obsIndex: number) =>
								obs && (
									<ObservationItem
										key={innerArray.rule + obsIndex}
										obs={obs}
										rule={innerArray.rule}
									/>
								)
						)}
					</ul>
					<RuleViewDetails
						innerArray={innerArray}
						selectedRule={selectedRule}
						close={close}
					/>
				</div>
			)}
		</div>
	);
};

const RulesEngine: React.FC<Props> = ({ close, ruledata }) => {
	const [filteredData, setFilteredData] = useState<any>([]);
	const [originalData, setOriginalData] = useState<any>(ruledata);

	const [expandedRule, setExpandedRule] = useState<any>(null);
	const [selectedRule, setSelectedRule] = useState<any>('Teradata Jobs Observability');
	const [selectedRuleItem, setSelectedRuleItem] = useState<any>('Teradata');
	const [activeButton, setActiveButton] = useState('Teradata');
	const [isRuleHasCount, setIsRuleHasCount] = useState<string[]>([]);

	useEffect(() => {
		setOriginalData(ruledata);
	}, [ruledata]);

	useEffect(() => {
		originalData[0]?.observations.map((item: any) => {
			if (!isRuleHasCount.includes(item.capability) && item.totalObservation) {
				setIsRuleHasCount((prevArray) => [...prevArray, item.capability]);
			}
		});
		setFilteredData(originalData);
	}, [originalData]);

	useEffect(() => {
		if (originalData && originalData.length > 0 && selectedRuleItem) {
			const filtered = originalData[0].observations.filter((item: any) => {
				if (item.capability === selectedRuleItem && item.totalObservation) {
					return item;
				}
			});
			setFilteredData(filtered); // Filter initial data with 'tableau' capability
		}
	}, [originalData]);

	const handleToggle = (index: number) => {
		setExpandedRule(expandedRule === index ? null : index);
	};

	const filterByCapability = (capability: string, isVVTabHighlight?: boolean) => {
		if (capability === 'Tableau') {
			setSelectedRule('Tableau Observability');
		} else if (capability === 'DataBricks') {
			setSelectedRule('Databricks Observability');
		} else if (capability === 'Teradata') {
			setSelectedRule('Teradata Jobs Observability');
		} else if (capability === 'Platformcost') {
			setSelectedRule('Platform Cost Observability');
		} else if (capability === 'Datagrowth') {
			setSelectedRule('Data Growth Observability');
		} else if (capability === 'Presto') {
			setSelectedRule('Presto Observability');
		} else if (capability === 'PowerBI') {
			setSelectedRule('Power BI Observability');
		} else if (capability === 'VV - PowerBI' || capability === 'VV - Tableau') {
			setSelectedRule('Verification & Validation Observability');
		} else if (capability === 'Denodo' || capability === 'Trifacta' || capability === 'Alteryx') {
			setSelectedRule('Controls & Compliance Observability');
		}
		setSelectedRuleItem(capability);
		setActiveButton(capability);

		// const filtered = originalData[0].observations.filter((item: any) => {
		// 	console.log(item.capability, 'capability test');

		// 	if (item.totalObservation && item.capability === capability) {
		// 		return item;
		// 	}
		// });

		let filtered: any[] = [];
		filtered = originalData[0].observations.filter((item: any) => {
			return item.totalObservation && item.capability === capability;
		});

		// Set the active button

		setFilteredData(filtered);
	};

	return (
		<div className="panel">
			<div className="container">
				<h2 className="panel-title">Alerts</h2>
				<div className="icons">
					<img src={envIcon} alt="Icon 3" />
					<img src={Emailicon} alt="Icon 2" />
					<button
						onClick={close}
						style={{
							background: 'none',
							border: 'none',
							padding: 0,
							cursor: 'pointer',
							display: 'inline-flex'
						}}
						title="Close"
					>
						<img className="icon-close" src={CloseIcon} alt="Icon 1" />
					</button>
				</div>
			</div>
			<div className="icon-container">
				<div className="icons icons-list">
					<div>
						<span className={'icon-group ' + (activeButton === 'Teradata' ? 'active' : '')}>
							<TeradataIcon
								className="rule-engine-icon"
								onClick={() => filterByCapability('Teradata')}
								fill="#333"
								stroke="#333"
							></TeradataIcon>
							{isRuleHasCount.includes('Teradata') && <span className="inner-circle"></span>}
						</span>
					</div>
					<div>
						<span className={'icon-group ' + (activeButton === 'Platformcost' ? 'active' : '')}>
							<DollarcircleIcon
								className="rule-engine-icon"
								onClick={() => filterByCapability('Platformcost')}
							></DollarcircleIcon>
							{isRuleHasCount.includes('Platformcost') && <span className="inner-circle"></span>}
						</span>
					</div>
					<div>
						<span className={'icon-group ' + (activeButton === 'Datagrowth' ? 'active' : '')}>
							<ChartIcon className="rule-engine-icon" onClick={() => filterByCapability('Datagrowth')}></ChartIcon>
							{isRuleHasCount.includes('Datagrowth') && <span className="inner-circle"></span>}
						</span>
					</div>
					<div>
						<span className={'icon-group ' + (activeButton === 'Tableau' ? 'active' : '')}>
							<TableauIcon className="rule-engine-icon" onClick={() => filterByCapability('Tableau')}></TableauIcon>
							{isRuleHasCount.includes('Tableau') && <span className="inner-circle"></span>}
						</span>
					</div>

					<div>
						<span className={'icon-group ' + (activeButton === 'DataBricks' ? 'active' : '')}>
							<DatabricksIcon
								className="rule-engine-icon"
								onClick={() => filterByCapability('DataBricks')}
							></DatabricksIcon>
							{isRuleHasCount.includes('DataBricks') && <span className="inner-circle"></span>}
						</span>
					</div>

					<div>
						<span className={'icon-group ' + (activeButton === 'Presto' ? 'active' : '')}>
							<PrestoIcon className="rule-engine-icon" onClick={() => filterByCapability('Presto')}></PrestoIcon>
							{isRuleHasCount.includes('Presto') && <span className="inner-circle"></span>}
						</span>
					</div>
					<div>
						<span className={'icon-group ' + (activeButton === 'PowerBI' ? 'active' : '')}>
							<PowerBIIcon className="rule-engine-icon" onClick={() => filterByCapability('PowerBI')}></PowerBIIcon>
							{isRuleHasCount.includes('PowerBI') && <span className="inner-circle"></span>}
						</span>
					</div>
					<div>
						<span className={'icon-group ' + (activeButton === 'VV - Tableau' || activeButton === 'VV - PowerBI'  ? 'active' : '')}>
							<VerificationIcon
								className="rule-engine-icon"
								onClick={() => filterByCapability('VV - Tableau')}
							></VerificationIcon>
							{isRuleHasCount.includes('VV - Tableau') && <span className="inner-circle"></span>}
						</span>
					</div>
					<div>
						<span className={'icon-group ' + (activeButton === 'Denodo' ||activeButton === 'Alteryx' ||activeButton === 'Trifacta' ? 'active' : '')}>
							<ControlsIcon className="rule-engine-icon" onClick={() => filterByCapability('Denodo')}></ControlsIcon>
							{isRuleHasCount.includes('Denodo') && <span className="inner-circle"></span>}
						</span>
					</div>
				</div>
			</div>
			<div className="selectedRule">{selectedRule}</div>

			{selectedRule === 'Verification & Validation Observability' && (
				<div className="controls_tools">
					{/* VV - Tableau Button */}
					<span className={'icon-group1 ' + (activeButton === 'VV - Tableau' ? 'active' : '')}>
						<TableauIcon
							className="rule-engine-icon VV-iconStyle"
							onClick={() => filterByCapability('VV - Tableau')}
						></TableauIcon>
						<button
							tabIndex={0}
							className="tool_title"
							onClick={() => filterByCapability('VV - Tableau')}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									filterByCapability('VV - Tableau');
								}
							}}
						>
							TABLEAU
							{isRuleHasCount.includes('VV - Tableau') && <span className="inner-circle"></span>}
						</button>
					</span>
					{/* PowerBIIcon Button */}

					<span className={'icon-group1 ' + (activeButton === 'VV - PowerBI' ? 'active' : '')}>
						<PowerBIIcon
							className="rule-engine-icon VV-iconStyle"
							onClick={() => filterByCapability('VV - PowerBI')}
						></PowerBIIcon>
						<button
							tabIndex={0}
							className="tool_title"
							onClick={() => filterByCapability('VV - PowerBI')}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									filterByCapability('VV - PowerBI');
								}
							}}
						>
							POWER BI
							{isRuleHasCount.includes('VV - PowerBI') && <span className="inner-circle"></span>}
						</button>
					</span>
				</div>
			)}
			{selectedRule === 'Controls & Compliance Observability' && (
				<div className="controls_tools">
					{/* Denodo Button */}
					<span className={'icon-group1 ' + (activeButton === 'Denodo' ? 'active' : '')}>
						{activeButton === 'Denodo' ? (
							<ActiveDenodoIcon className="rule-engine-icon" onClick={() => filterByCapability('Denodo')} />
						) : (
							<DenodoIcon className="rule-engine-icon" onClick={() => filterByCapability('Denodo')} />
						)}
						<button
							tabIndex={0}
							className="tool_title"
							onClick={() => filterByCapability('Denodo')}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									filterByCapability('Denodo');
								}
							}}
						>
						DENODO
							{isRuleHasCount.includes('Denodo') && <span className="inner-circle"></span>}
						</button>
					</span>

					{/* Alteryx Button */}
					<span className={'icon-group1 ' + (activeButton === 'Alteryx' ? 'active' : '')}>
						<AlteryxIcon className="rule-engine-icon" onClick={() => filterByCapability('Alteryx')}></AlteryxIcon>
						<button
							tabIndex={0}
							className="tool_title"
							onClick={() => filterByCapability('Alteryx')}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									filterByCapability('Alteryx');
								}
							}}
						>
							ALTERYX
							{isRuleHasCount.includes('Alteryx') && <span className="inner-circle"></span>}
						</button>
					</span>

					{/* Trifacta Button */}
					<span className={'icon-group1 ' + (activeButton === 'Trifacta' ? 'active' : '')}>
						<TrifactaIcon className="rule-engine-icon" onClick={() => filterByCapability('Trifacta')}></TrifactaIcon>
						<button
							tabIndex={0}
							className="tool_title"
							onClick={() => filterByCapability('Trifacta')}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									filterByCapability('Trifacta');
								}
							}}
						>
						TRIFACTA
							{isRuleHasCount.includes('Trifacta') && <span className="inner-circle"></span>}
						</button>
					</span>
				</div>
			)}

			{filteredData?.map((innerArray: any, index: number) => (
				<RuleObservationGroup
					key={innerArray.rule}
					innerArray={innerArray}
					index={index}
					expandedRule={expandedRule}
					handleToggle={handleToggle}
					selectedRule={selectedRule}
					close={close}
				/>
			))}
		</div>
	);
};

export default RulesEngine;
